var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ContextMenu,{attrs:{"options":_setup.FireOutbreakReactionOptionsFactory.make(_vm.alert.reaction),"icon":_setup.icon,"icon-color":_setup.iconColor},on:{"change":function($event){return _setup.emit('reaction', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }